import { Container, Stack, Typography } from "@mui/material";
import React from "react";
import RegisterHeader from "./Common/Header";

import Chart from "../../assets/images/chart.png";
import Footer from "../Footer";

const RegisterAnalysis = () => {
  return (
    <div className="Register">
      <RegisterHeader />

      <Container maxWidth="sm" className="MainContainer">
        <Stack alignItems={"center"}>
          <img src={Chart} style={{ marginTop: "170px", width: "254px" }} />
          <Typography
            variant="h1"
            color="initial"
            sx={{
              fontWeight: 700,
              fontSize: "25px",
              color: "#46558C",
              mt: "50px",
            }}
          >
            Seu cadastro ainda está em análise
          </Typography>
          <Typography
            variant="body2"
            color="initial"
            align="center"
            fontWeight={400}
            fontSize={"16px"}
            mt={"32px"}
          >
            Assim que o processo for concluído, você receberá uma notificação
            via e-mail. Se precisar de ajuda, estamos aqui para você.
          </Typography>
        </Stack>
      </Container>

      <Footer/>
    </div>
  );
};

export default RegisterAnalysis;
